module.exports = __webpack_public_path__ + "media/site_templates/www.pianomovingservice.com.au/images/our_services_3-13ac501da5f8ed95a6d5b6c2fa0a4d1c.jpg";